<template>
  <div id="map-container">
    <l-map :zoom="zoom" :center="center" @update:bounds="boundsUpdate">
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

      <v-marker-cluster>
        <l-marker
        v-for="marker in markers"
        v-bind:key="marker.ComercioID"
        :lat-lng="marker.Latlng"
        :icon="icon"
        @click="markerClicked"
      >
        <l-popup :content="marker.Content" />
      </l-marker>
      </v-marker-cluster>
      

      <v-geosearch :options="geosearchOptions"></v-geosearch>
    </l-map>
  </div>
</template>

<style>
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
#map-container {
  width: 100%;
  height: 700px;
  margin-top: 100px;
}

.leaflet-popup-content {
  width: 200px !important;
}

.geosearch .reset {
  display: none;
}

.geosearch .leaflet-bar-part {
  display: none;
}

.geosearch .results {
  background-color: white;
}

.geosearch input {
  background-clip: padding-box;
  background-color: rgb(255, 255, 255);
  color: rgb(73, 80, 87);
  border-bottom-color: rgb(206, 212, 218);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 0px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-image-outset: 0px;
  border-image-repeat: stretch;
  border-image-slice: 100%;
  border-image-source: none;
  border-image-width: 1;
  border-left-color: rgb(206, 212, 218);
  border-left-style: solid;
  border-left-width: 1px;
  border-right-color: rgb(73, 80, 87);
  border-right-style: none;
  border-right-width: 0px;
  border-top-color: rgb(206, 212, 218);
  border-top-left-radius: 4px;
  border-top-right-radius: 0px;
  border-top-style: solid;
  border-top-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  cursor: text;
  display: block;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-stretch: 100%;
  font-weight: 400;
  height: 38px;
  letter-spacing: normal;
  line-height: 24px;
  padding-bottom: 6px;
  padding-left: 12px;
  padding-right: 0px;
  padding-top: 6px;
  word-spacing: 0px;
  width: 100%;
  min-width: 350px;
}

.logoMapa {
  width: 50px;
  border: 2px solid #ff4940;
  border-radius: 50%;
  margin: 5px;
}

.ServiceOn {
  -webkit-filter: grayscale(0%); /* Safari 6.0 - 9.0 */
  filter: grayscale(0%);
  width: 20px;
  margin: 5px;
  display: inline-block;
}

.ServiceOff {
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
  width: 20px;
  margin: 5px;
  display: inline-block;
}

.containerdiv {
  display: inline-block;
  position: relative;
}

.coverimage {
  position: absolute;
  top: 4px;
  right: 5px;
  width: 20px;
}

.color-primary.nunito {
  color: #ff4940 !important;
}
</style>

<script>
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import VGeosearch from "vue2-leaflet-geosearch";
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster'

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    VGeosearch,
    'v-marker-cluster': Vue2LeafletMarkercluster
  },

  data() {
    return {
      zoom: 15,
      center: L.latLng(-32.964492, -60.692204),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markers: [],
      icon: L.icon({
        iconUrl: "img/markers/map_marker1_medio.png",
        iconSize: [32, 44],
        iconAnchor: [20, 20]
      }),
      geosearchOptions: {
        // Important part Here
        provider: new OpenStreetMapProvider(),
        autoClose: true,
        searchLabel: "Ingresa tu localidad"
      },
      timer: null
    };
  },
  beforeMount: function() {},
  mounted: function() {
    navigator.geolocation.getCurrentPosition(this.success);

    let req = {
      minLat: this.center.lat - 1,
      maxLat: this.center.lat + 1,
      minLong: this.center.lng - 1,
      maxLong: this.center.lng + 1,
      centerLat: this.center.lat,
      centerLong: this.center.lng
    };

    this.getMarkers(req);
  },
  methods: {
    getMarkers(req) {
      let context = this;

      axiosHelpers.axiosGet("Commerce/GetNear", req, this, function(data) {
        context.markers = [];

        for (var i = 0; i < data.ResponseVM.length; i++) {
          let item = data.ResponseVM[i];

          //   let img = "img/brand/services/comercio.png";
          //   if (item.Image != "") {
          //     img = item.Image;
          //   }

          let content = "";

          content += '<div style="width:100%"><center>';
          content +=
            '<img src="' + item.Image + '" class="logoMapa img-fluid"/><p>';

          content +=
            '<span><b class="color-primary nunito">' +
            item.Name +
            "</b></span><br />";
          content += '<span class="nunito">' + item.Address + "</span>";
          content += '<div style="width:100%">';

          for (let j = 0; j < item.Services.length; j++) {
            let service = item.Services[j];
            content +=
              '<div class="containerdiv"><img src="' +
              service.Image +
              '" class="ServiceOn" alt="' +
              service.Name +
              '" title="' +
              service.Name +
              '"/>';
            content += "</div>";
          }

          content += "</div></p></center>";

          let newMarker = {
            Nombre: item.Name,
            Direccion: item.Address,
            Imagen: '"' + item.Image + '"',
            Latlng: L.latLng(item.Latitude, item.Longitude),
            ComercioID: item.CommerceID,
            Content: content
          };

          context.markers.push(newMarker);
        }
      });
    },
    boundsUpdate(bounds) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        let req = {
          minLat: bounds._southWest.lat,
          maxLat: bounds._northEast.lat,
          minLong: bounds._southWest.lng,
          maxLong: bounds._northEast.lng,
          centerLat: bounds.getCenter().lat,
          centerLong: bounds.getCenter().lng
        };

        this.getMarkers(req);
      }, 800);
    },
    markerClicked(e) {
      this.center = e.latlng;
    },
    success(data) {
      this.center = L.latLng(data.coords.latitude, data.coords.longitude);
    }
  }
};
</script>
